import React from 'react';
import {Tabs} from "antd";
import Listing from "./EnrolmentListing";
import EnrolmentChart from "./EnrolmentChart";

const { TabPane } = Tabs;

const EnrolmentTracking = () => {

    return  <div>
        <Tabs defaultActiveKey="1">
            <TabPane tab="Graph view" key="1">
                <EnrolmentChart />
            </TabPane>
            <TabPane tab="List view" key="2">
                <Listing />
            </TabPane>
        </Tabs>
    </div>

}

export default EnrolmentTracking
